import DashboardLayout from "@/components/layouts/DashboardLayout"
import WaitlistSettingsMenu from "@/components/common/Menus/WaitlistSettingsMenu"
import classNames from "classnames"
import styles from "@/styles/Manage.module.scss"
import { ReactNode } from "react"
import usePageLoading from "@/hooks/usePageLoading"

interface Props {
  children: ReactNode
  title: string
  shouldLoadWholePage?: boolean
}

function WaitlistSettingsLayout({ children, shouldLoadWholePage }: Props) {
  const isPageLoading = usePageLoading(shouldLoadWholePage)

  return (
    <DashboardLayout
      title={`Settings`}
      headerNavProps={{ showLocationPicker: true }}
    >
      <div className={classNames(styles.pageWrapper)}>
        <div className={classNames("flex flex-column items-start")}>
          <WaitlistSettingsMenu />
          <div className={styles["manage-content"]}>
            {!isPageLoading && children}
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default WaitlistSettingsLayout
